/**
 * Measuring the www.mtlblog.com frontends, RebelMouse against the Expo app
 * (plans/mtlblog-www-expo-frontend.md, "Measuring Expo against RM", D19).
 *
 * On these hosts every GAM request carries the page's frontend (`fe`) and URL
 * band (`pb`), and a sample of pages sends LCP, INP and CLS to the page's GA4
 * through gtag (lib/frontendMeasurement.js; the report's own settings are in
 * lib/vitals/config.js). The band is the edge Worker's cohort bucket divided
 * by 100: FNV-1a (32-bit) of the lowercased path without trailing slashes,
 * modulo 10,000 (mtlblog-app/edge/src/router.js;
 * dev/tests/mtlblog-frontend-arm.contract.js checks that both agree). Reports
 * group bands into the canary's arms, so a canary step needs no SDK release.
 * Edit here and rebuild the SDK.
 */
module.exports = {
  FRONTEND_MEASUREMENT: Object.freeze({
    hosts: Object.freeze(['www.mtlblog.com', 'www-next.mtlblog.com', 'edge-test.mtlblog.com']),
    // The Expo pages declare themselves; every other page is RebelMouse.
    frontendMetaName: 'mtl-frontend',
    frontends: Object.freeze(['rm', 'expo']),
    defaultFrontend: 'rm',
    bucketCount: 10000,
    bandSize: 100,
    // GAM key-values; the owner creates both keys as reportable.
    gamFrontendKey: 'fe',
    gamBandKey: 'pb',
    vitalsSampleRate: 0.2
  })
};
